export const componentsSlugs = {
  MAIN_SLIDER: 'main_slider',
  STORE: 'la_tienda',
  ABOUT: 'about_us',
  NEWSLETTER: 'newsletter',
  ADVANTAGES: 'advantages',
  SUBSCRIPTION: 'subscription_block',
}
